import { uid } from "uid";
function generateUniqueId() {
  return uid();
}
export { generateUniqueId as default };